import React from "react";
import { Link } from "react-router-dom";
import { StatusBadge } from "@/components/StatusBadge";
import { SourceBadge } from "@/components/SourceBadge";
import { formatDate, formatKr, daysLabel } from "@/lib/format";
import { ShieldAlert, ChevronRight } from "lucide-react";

/** Kompakt kortliste for mobil (erstatter tabell under md). */
export const InvoiceCardList = ({ items, categories = {} }) => (
  <ul className="space-y-2" data-testid="invoice-card-list">
    {items.map((inv) => (
      <li key={inv.id}>
        <Link to={`/fakturaer/${inv.id}`} className="block rounded-xl border bg-card p-4 active:bg-secondary transition-colors" data-testid={`invoice-card-${inv.id}`}>
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="font-medium truncate flex items-center gap-1.5">
                {inv.flags?.length ? <ShieldAlert className="h-4 w-4 text-flag shrink-0" /> : null}
                {inv.issuer_name || <span className="text-muted-foreground italic">Ukjent avsender</span>}
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                {inv.due_date ? `Forfall ${formatDate(inv.due_date)}` : "Forfall mangler"}
                {inv.days_to_due !== null && inv.status !== "betalt" && inv.status !== "avvist" ? ` · ${daysLabel(inv.days_to_due)}` : ""}
              </p>
            </div>
            <div className="text-right shrink-0">
              <p className="font-semibold tnum whitespace-nowrap">{formatKr(inv.amount, inv.currency)}</p>
            </div>
          </div>
          <div className="mt-3 flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 min-w-0">
              <StatusBadge status={inv.display_status || inv.status} />
              <SourceBadge source={inv.source} className="hidden xs:inline-flex" />
              {inv.category_id && categories[inv.category_id] ? <span className="hidden sm:inline-flex items-center gap-1 text-xs text-muted-foreground"><span className="h-2 w-2 rounded-full" style={{ background: categories[inv.category_id].color }} />{categories[inv.category_id].name}</span> : null}
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
          </div>
        </Link>
      </li>
    ))}
  </ul>
);
